// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"r1-z","displaySixCardTiles":"s1-z"};